// ===== Packages =====

import * as Y                                       from 'yjs';
import { WebsocketProvider }                        from 'y-websocket';

export interface IPostCollaborativeSession {
    doc: Y.Doc,
    provider: WebsocketProvider,
    destroy: () => void,
}

const createPostCollaborativeSession = ({
    docId,
    authToken,
    test,
    websocketURL,
    autoConnect = true,
}: {
    docId: string,
    authToken: string,
    test: boolean,
    websocketURL?: string,
    autoConnect?: boolean,
}): IPostCollaborativeSession => {
    const resolvedWebsocketURL = websocketURL || process.env.REACT_APP_POST_COLLAB_WEBSOCKET_URL;
    if (!resolvedWebsocketURL) {
        throw new Error('Missing REACT_APP_POST_COLLAB_WEBSOCKET_URL for collaborative post editing.');
    }

    const doc = new Y.Doc();
    const provider = new WebsocketProvider(
        resolvedWebsocketURL,
        docId,
        doc,
        {
            connect: autoConnect,
            params: {
                token: authToken,
                test: test ? 'true' : 'false',
            },
        },
    );

    return {
        doc,
        provider,
        destroy: (): void => {
            provider.destroy();
            doc.destroy();
        },
    };
};

export default createPostCollaborativeSession;
